import React, { ReactNode } from "react";
import { SanityImage } from "../../model/common";
import { urlForDocument, URLParts } from "../../urls";
import ArticleTagInfo from "../ArticleTagInfo/ArticleTagInfo";
import CardContent from "../CardContent/CardContent";
import { BreakpointValues, ImageRatios } from "../Image/Image";
import ImageCard from "../ImageCard/ImageCard";

export interface ArticleCardFields extends URLParts {
  title: string;
  image: SanityImage;
  description?: string;
  subtitle?: string;
}

interface ArticleCardProps {
  article: ArticleCardFields;
  readMore?: boolean;
  textMaxLines?: number;
  content?: ReactNode;
  widths?: BreakpointValues;
  titleBefore?: ReactNode;
  tags?: ReactNode;
  className?: string;
  titleAs?: string;
}

const ArticleCard = ({
  article,
  readMore = true,
  textMaxLines = 2,
  className,
  content,
  tags,
  titleBefore,
  widths = 270,
  titleAs
}: ArticleCardProps) => {
  return (
    <ImageCard
      widths={widths}
      key={article._id}
      image={article.image}
      aspectRatio={
        article._type === "globalGoalsResource"
          ? ImageRatios.Square
          : ImageRatios.Landscape_4_3
      }
      padded={article._type === "unitOfWork"}
      className={className}
      href={urlForDocument(article)}
    >
      <CardContent
        titleAs={titleAs}
        title={article.title}
        href={urlForDocument(article)}
        tags={tags ?? <ArticleTagInfo article={article} />}
        textMaxLines={textMaxLines}
        text={article.description ?? article.subtitle}
        titleBefore={titleBefore}
        readMore={readMore}
      >
        {content}
      </CardContent>
    </ImageCard>
  );
};

export default ArticleCard;
